import { Button } from '@cfa/react-core';
import { FC } from 'react';
import { themeColors, themeSizes } from '../../../../styles/globalStyleVars';
import { TypographyStyled } from '../../../Styled/Typography';
import useBreakpoints from '../../../../hooks/useBreakpoints';
import useMediaQuery from '../../../../hooks/useMediaQuery';

interface ItemProps {
  button: string;
  description: string;
  handleClick: () => void;
  icon: React.JSX.Element;
  title: string;
}

const Item: FC<ItemProps> = ({
  button,
  description,
  handleClick,
  icon,
  title,
}) => {
  const breakpoints = useBreakpoints();
  const isLgAndUp = useMediaQuery(breakpoints.up('lg'));
  return (
    <div
      data-testid={'onboarding-item'}
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: isLgAndUp ? '0 1 184px' : '1 1 0',
        minWidth: 0,
      }}
    >
      <div>{icon}</div>
      <div>
        {
          <TypographyStyled
            text={title}
            color={themeColors.colorGray_7}
            fontWeight='bold'
            style={{
              marginTop: `${themeSizes.md}`,
            }}
            variant='body2'
          />
        }
      </div>
      <div style={{ marginTop: themeSizes.xs }}>
        <TypographyStyled
          text={description}
          color={themeColors.colorGray_7}
          variant='body2'
        />
      </div>
      <div style={{ marginTop: 'auto', paddingTop: `${themeSizes.md}` }}>
        {
          <Button
            onPress={handleClick}
            size='sm'
            style={{ minWidth: '100%' }}
            variant='outlined'
          >
            {button}
          </Button>
        }
      </div>
    </div>
  );
};

export default Item;
